import { render, staticRenderFns } from "./linkedfeatures.vue?vue&type=template&id=d200015c"
import script from "./linkedfeatures.vue?vue&type=script&lang=ts"
export * from "./linkedfeatures.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports